module.exports = __webpack_public_path__ + "bbf2aaff2820caf1e8dc42c4ff5b88a5.pdf";